import type { HTMLAttributes, Ref } from 'react'
import styles from './linear-progress.module.css'

export interface LinearProgressProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'indeterminate' | 'determinate'
  value?: number
  color?: 'primary' | 'secondary'
  ref?: Ref<HTMLDivElement>
}

const colorMap: Record<string, string | undefined> = {
  secondary: styles.colorSecondary,
}

export const LinearProgress = ({
  variant = 'indeterminate',
  value,
  color = 'primary',
  className,
  ref,
  ...rest
}: LinearProgressProps) => {
  const classes = [
    styles.root,
    variant === 'indeterminate' ? styles.indeterminate : undefined,
    colorMap[color],
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div
      ref={ref}
      role="progressbar"
      aria-valuenow={variant === 'determinate' ? (value ?? 0) : undefined}
      aria-valuemin={0}
      aria-valuemax={100}
      className={classes}
      data-motion-essential={variant === 'indeterminate' ? '' : undefined}
      {...rest}
    >
      <div>
        <span className={styles.bar} style={variant === 'determinate' ? { width: `${value ?? 0}%` } : undefined} />
        {variant === 'indeterminate' ? <span className={styles.bar} /> : null}
      </div>
    </div>
  )
}
